import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"


import globalMU from "globalMU"

declare var window: any

export type definirEncomendaExpressaItemInput = {

    identificadorItem: number,
    encomendaExpressa: boolean,
    itemOrcamentoLegado?: any
}

export async function definirEncomendaExpressaItem(input: definirEncomendaExpressaItemInput) {  // 433263
    const orcamentoAtualizado = await microuniversoApi.Orcamento.definirEncomendaExpressaItem(
        store.getState().orcamento.IdentificadorOrcamento,
        input.identificadorItem,
        input.encomendaExpressa)

    const atualizarOrcamento = () => {
        const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem);
        store.dispatch(atualizarItemAction({ identificador: input.identificadorItem, dados: itemAtualizado }))
        store.dispatch(sobrescreverInformacoesAction(orcamentoAtualizado))
    }

    atualizarOrcamento()
}